import api from "../utils/api";
import { getDictionary, getMarketLanguage } from "./siteService";
import { isEmptyObject } from "../utils/siteUtils";
import { dictTypes, orderTypes, siteErrorCodes } from "../utils/lynkco-constants";
import storeApi from "../utils/storeApi";
import store from "../redux/store/store";
import { selectUserState, staffInfoSelector } from "../selectors/application";

export const getDeliveryMethods = async spuIds => {
  const deliveryDict = await getDictionary(dictTypes.deliveryMethod);
  const language = getMarketLanguage();
  const { obj: methods } = await api.spu.deliveryMethod.list(null, { spuIds });
  if (methods !== null) {
    for (let method of methods) {
      const dict = deliveryDict.find(d => d.dicCode === method.deliveryMethodCode);
      method.name = dict?.languages[language].dicName;
      method.description = dict?.languages[language].dicName;
    }
    return methods;
  } else {
    return [];
  }
};
export const getDeliveryMethodInfo = async dicCode => {
  const deliveryDict = await getDictionary(dictTypes.deliveryMethod);
  const language = getMarketLanguage();
  const dict = deliveryDict.find(d => d.dicCode === dicCode);
  return dict?.languages[language];
};
export const saveOrderInner = async (billingInfoData, skuQtyVoList, inStore = false, club) => {
  const orderApi = inStore ? storeApi : api;
  const state = store.getState();
  const user = selectUserState(state);
  const staffInfo = staffInfoSelector(state);
  const body = {
    customerEmail: billingInfoData.billingEmail,
    customerAccount: user.userAccount,
    userAccount: user.userAccount,
    skuQtyVoList,
    subType: orderTypes.presale,
    billingAddress: billingInfoData,
    contactEmail: billingInfoData.billingEmail,
    contactMobile: billingInfoData.billingPhone
  };
  if (inStore) {
    if (isEmptyObject(club)) {
      throw {
        code: siteErrorCodes.clubNotSelected
      };
    }
    body.storeCode = club.code;
    body.staff = staffInfo?.account.userName;
  }
  return orderApi.order.save(null, body);
};
export const saveOrder = async (billingInfoData, skuQtyVoList) => {
  return saveOrderInner(billingInfoData, skuQtyVoList);
};
export const saveInStoreOrder = async (billingInfoData, skuQtyVoList, club) => {
  return saveOrderInner(billingInfoData, skuQtyVoList, true, club);
};

export const getOrderDetail = async orderId => {
  try {
    const res = await api.order.detail({ id: orderId });
    return res?.obj;
  } catch (err) {
    return err.obj;
  }
};
export const getOrderDetailByNo = async orderNo => {
  const { obj } = await api.order.detailByNo({ no: orderNo });
  return obj;
};
export const getInStoreOrderDetail = async orderId => {
  const res = await storeApi.order.detail({ id: orderId });
  return res.obj;
};
export const getNoLoginOrderDetail = async (email, suborderNo) => {
  let suborderNoValue = suborderNo?.length ? suborderNo[0] : "";
  const res = await api.order.queryByNoAndEmail(null, {
    customerEmail: email,
    suborderNo: suborderNoValue
  });
  return res.obj;
};
export const getOrderStatus = async orderNo => {
  try {
    const res = await api.order.payment.info(null, {
      orderNo: orderNo
    });
    return res;
  } catch (err) {
    return err;
  }
};
export const getInstoreOrderStatus = async orderNo => {
  try {
    const res = await storeApi.payment.info(null, {
      orderNo: orderNo
    });
    return res;
  } catch (err) {
    return err;
  }
};
